import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Topic from '../Topic';

const CatWrapper = styled.div`
  display: flex;
  flex: ${props => props.double};
  flex-direction: column;
  text-align: center;
`;

const Topics = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-top: 40px;
`;

class Category extends Component {
  static propTypes = {
    model: PropTypes.string,
    topics: PropTypes.array
  };

  render() {
    const { model, topics } = this.props;
    const maxHeight = 6;
    const double = topics.length > maxHeight ? 2 : 1;
    return (
      <CatWrapper double={double}>
        <Topics>
          {topics.map((topic, i) => {
            return (
              <Topic
                model={model}
                image={topic.topicImage}
                key={i}
                topic={topic}
              />
            );
          })}
        </Topics>
      </CatWrapper>
    );
  }
}

export default Category;



// WEBPACK FOOTER //
// ./src/components/Category/Category.js